import { ENABLED, DISABLED, FULL_STORY, LOAN_TYPE_FILTER, ZABLE, BANKRATE_IFRAME } from './const'

export default {
  [LOAN_TYPE_FILTER]: {
    default: ENABLED,
    development: ENABLED,
    develop: ENABLED,
    uat: ENABLED,
    stage: ENABLED,
    production: ENABLED,
  },
  [FULL_STORY]: {
    default: ENABLED,
    development: ENABLED,
    develop: ENABLED,
    uat: DISABLED,
    stage: DISABLED,
    production: DISABLED,
  },
  [ZABLE]: {
    default: ENABLED,
    development: ENABLED,
    develop: ENABLED,
    uat: ENABLED,
    stage: ENABLED,
    production: ENABLED,
  },
  [BANKRATE_IFRAME]: {
    default: ENABLED,
    development: ENABLED,
    develop: ENABLED,
    uat: ENABLED,
    stage: ENABLED,
    production: ENABLED,
  },
}
